module.exports = __webpack_public_path__ + "img/borderHeartWhite.b95d6ac1.svg";